<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title">{{title}}</h5>
  </div>
  <div class="modal-body">
    <form [formGroup]="formUnlockAccess">
      <div *ngIf="!isUnlockStudent">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label for="nationalId" class="col-form-label">{{'@direction.pages.popupCredential.nationalId' | translate }}</label>
              <input type="text" class="form-control" id="nationalId" mask="000.000.000-00" formControlName="nationalId">
            </div>
          </div>
        </div>
        <div class="row" [ngClass]="{'d-none': !showName}">
          <div class="col-md-12">
            <div class="form-group">
              <label for="recipient-name" class="col-form-label">{{'@direction.pages.popupCredential.name' | translate }}</label>
              <input type="text" class="form-control" id="recipient-name" formControlName="name">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label for="recipient-name" class="col-form-label">{{'@direction.pages.popupCredential.profile' | translate }}</label>
            <br>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="profile" id="stranger" value="1" formControlName="profile">
              <label class="form-check-label" for="stranger">{{'@direction.pages.popupCredential.stranger' | translate }}</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="profile" id="serviceProvider" value="2" formControlName="profile">
              <label class="form-check-label" for="serviceProvider">{{'@direction.pages.popupCredential.serviceProvider' | translate
                }}</label>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="reason" class="col-form-label">{{'@direction.pages.popupCredential.reason' | translate }}</label>
            <textarea class="form-control" id="reason" formControlName="reason"></textarea>
          </div>
        </div>
      </div>

    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" [disabled]="!formUnlockAccess.valid" data-bs-dismiss="modal"
      (click)="onConfirm()">Liberar</button>
    <button type="button" class="btn btn-secondary" (click)="onClose()">Cancelar</button>
  </div>
</div>
